// Global theme of the webapp

import Montserrat from "./assets/fonts/Montserrat.ttf";
import { createTheme } from "@mui/material";

const theme = createTheme({
  typography: {
    fontFamily: "Montserrat, sans-serif",
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        @font-face {
          font-family: 'Montserrat';
          font-style: normal;
          font-display: swap;
          font-weight: 400;
          src: local('Montserrat'), url(${Montserrat}) format('woff2');
          unicodeRange: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF;
        }
      `,
    },
  },
  colorSchemes: {
    light: {
      palette: {
        primary: {
          main: "#009af0",
        },
        background: {
          main: "#ffffff",
          github: "#24292f",
        },
        navbarFooter: {
          main: "#e4ebf7",
        },
        paperBorder: {
          main: "#000000",
        },
      },
    },
    dark: {
      palette: {
        primary: {
          main: "#009af0",
        },
        background: {
          main: "#000814",
          github: "#fff",
        },
        navbarFooter: {
          main: "#252b34",
        },
        paperBorder: {
          main: "#d6dde8",
        },
      },
    },
  },
});

export default theme;
